import React from 'react'
import PropTypes from 'prop-types'
import SubmitButton from '../../../../uiKit/buttons/SubmitButton'
import Input from '../../../../uiKit/inputs/Input'
import classes from './styles.module.scss'

const EmailCredentialsForm = props => {
  const { senderEmail, redirectionEmail, receiverEmail, onEdit, enabled, activeBotId } = props
  return (
    <div style={{ opacity: enabled ? 1 : 0.5 }} className={classes.credentialsCard}>
      <div className={classes.credentialsHeader}>
        <div className={classes.credentialsTitle}>Email Credentials</div>
        <SubmitButton
          title="Edit"
          type="primary_with_border"
          onClick={enabled ? onEdit : undefined}
          className={classes.editButton}
        />
      </div>

      <div className={classes.credentialsGrid}>
        <div className={classes.credentialsRow}>
          <div className={classes.credentialsLabel}>Sender email ID</div>
          <div className={`${classes.inputWrap} ${classes.credentialsInput}`}>
            <Input
              title={null}
              placeholder="e.g. noreply@companyname.com"
              value={senderEmail || ''}
              inputTitleStyles={{ margin: 0 }}
              disabled
            />
          </div>
        </div>

        <div className={classes.credentialsRow}>
          <div className={classes.credentialsLabel}>Redirection email ID</div>
          <div className={`${classes.inputWrap} ${classes.credentialsInput}`}>
            <Input
              title={null}
              placeholder="Redirection email ID"
              value={redirectionEmail || ''}
              inputTitleStyles={{ margin: 0 }}
              disabled
            />
          </div>
        </div>

        <div className={classes.receiverRow}>
          <div className={classes.credentialsLabel}>CareBrain email ID</div>
          <div className={`${classes.inputWrap} ${classes.credentialsInput} ${classes.receiverInput}`}>
            <Input
              title={null}
              placeholder="Receiver’s email ID"
              value={receiverEmail || ''}
              inputTitleStyles={{ margin: 0 }}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  )
}

EmailCredentialsForm.propTypes = {
  senderEmail: PropTypes.string,
  redirectionEmail: PropTypes.string,
  receiverEmail: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
}

export default EmailCredentialsForm